import { FLOW_REDUCERS_TYPE } from './constants';
import { manipulateCarData } from './helpers';

const initialState = {
    showAllCTA: true,
    valuationFormFields: [],
    isRegistrationUrlAPICalled: false,
    valuationMakePairs: null,
    carDetails: null
};

const valuationFlow = (state = initialState, action) => {
    switch (action.type) {
        case FLOW_REDUCERS_TYPE.UPDATE_SHOW_ALL_HP:
            return {
                ...state,
                showAllCTA: action.value
            };
        case FLOW_REDUCERS_TYPE.RECEIVE_VALUATION_FORM_FIELDS:
            return {
                ...state,
                valuationFormFields: action.data.data
            };
        case FLOW_REDUCERS_TYPE.RECEIVE_VALUATION_FORM_DATA_VALUES_MAKE:
            return {
                ...state,
                valuationMakePairs: action.data.data
            };
        case FLOW_REDUCERS_TYPE.IS_REGISTRATION_API_CALLED:
            return {
                ...state,
                isRegistrationUrlAPICalled: action.value
            };
        case FLOW_REDUCERS_TYPE.RECEIVE_VALUATION_FORM_REGISTRATION:
            return {
                ...state,
                carDetails: manipulateCarData(state, action.data),
                isRegistrationUrlAPICalled: true
            };
        default:
            return state;
    }
};

export default valuationFlow;
